import WebinarBanner, {
  BannerSpec,
} from '@invideoio/web-shared/components/WebinarBanner';
import { useAnnouncementBanners } from '@store/AnnouncementBannerContext';
import { sendAmplitudeAnalyticEvent } from '@utils/analytics';

// The banner rotates through several slides, so the event is labelled with the
// slide that was actually clicked rather than assuming the webinar one.
const handleBannerClick = (spec: BannerSpec) =>
  sendAmplitudeAnalyticEvent('webinar_register_clicked', {
    ux_source: 'tools-banner',
    cta: spec.analyticsCta,
  });

// Thin consumer wrapper around the shared WebinarBanner that wires Amplitude.
// Accepts (and ignores) `browser` so it's a drop-in for the StudioBanner call sites.
const ToolsWebinarBanner = (_props: { browser?: unknown }) => {
  // CMS slides when the CMS answered; `undefined` (no answer) lets WebinarBanner
  // fall back to its own hardcoded defaults. An empty list means the CMS says there
  // is no bar right now, which WebinarBanner itself renders as nothing.
  const banners = useAnnouncementBanners();

  return (
    <WebinarBanner banners={banners ?? undefined} onClick={handleBannerClick} />
  );
};

export default ToolsWebinarBanner;
